import React from 'react';
import { PenTool, Film, Zap, Users, Check, Clock, AlertCircle } from 'lucide-react';

// Get icon component based on name
export const getIconComponent = (iconName, size = 20) => {
  switch(iconName) {
    case 'PenTool': return <PenTool size={size} />;
    case 'Film': return <Film size={size} />;
    case 'Zap': return <Zap size={size} />;
    case 'Users': return <Users size={size} />;
    default: return <PenTool size={size} />;
  }
};

// Get status icon based on task status
export const getStatusIcon = (status) => {
  switch(status) {
    case 'completed':
      return <Check className="text-green-500" size={18} />;
    case 'in-progress':
      return <Clock className="text-yellow-500" size={18} />;
    case 'not-started':
      return <AlertCircle className="text-gray-400" size={18} />;
    default:
      return null;
  }
};

// Get project status info (color, icon, text)
export const getProjectStatusInfo = (status) => {
  switch(status) {
    case 'on-track':
      return { 
        color: 'bg-green-500', 
        icon: <Check size={18} className="text-green-500" />, 
        text: 'On Track' 
      };
    case 'delayed':
      return { 
        color: 'bg-yellow-500', 
        icon: <Clock size={18} className="text-yellow-500" />, 
        text: 'Delayed' 
      };
    case 'at-risk':
      return { 
        color: 'bg-red-500', 
        icon: <AlertCircle size={18} className="text-red-500" />, 
        text: 'At Risk' 
      };
    default:
      return { 
        color: 'bg-gray-500', 
        icon: null, 
        text: 'Unknown' 
      };
  }
};

export default {
  getIconComponent,
  getStatusIcon,
  getProjectStatusInfo
};